export const apiGetListCustomer = "/1.0/wsm/dropdownlist/customers"
export const apiGetListPackage = "/1.0/wsm/package/listall"
export const apiGetListSupplier = "/1.0/wsm/supplier/listall"
export const apiGetListNetwork = "/1.0/wsm/network/listall"
export const apiCountries = "/1.0/wsm/dropdownlist/countries"
export const apiGetListBank = "/1.0/wsm/dropdownlist/bank"
export const apiWarehouseApproval = "/1.0/wsm/warehouse/listall"
export const apiGetListCountry = "/1.0/wsm/dropdownlist/countries/network"
export const apiGetListCustomerB2B = "/1.0/user/list/child"
